// DTOs de C10 — costo de mano de obra ($/hora-persona) con vigencia (WS-5).
//
//   - GET  /api/coordinador/configuracion/costo-mano-obra  — vigente + histórico
//   - POST /api/coordinador/configuracion/costo-mano-obra  — fijar nueva vigencia
//
// El valor es por planta del coordinador (override) con fallback al tenant-wide
// (planta_id NULL). Editar crea una nueva vigencia, nunca pisa la historia.
// Gateado por la capacidad `puede_ver_costos` (gate duro en el backend).
import { z } from 'zod';
/** Una fila del histórico de costo MO (tabla costos_mano_obra). */
export const costoManoObraHistoricoItemSchema = z.object({
    id: z.string().uuid(),
    valor_hora_persona_cop: z.number(),
    vigente_desde: z.string(),
    vigente_hasta: z.string().nullable(),
    /** Nombre de quien registró el cambio (columna "CAMBIÓ" en la UI). */
    registrado_por_nombre: z.string().nullable(),
});
export const costoManoObraResponseSchema = z.object({
    /** Valor vigente para la planta del coordinador (o tenant-wide). null si no hay. */
    vigente: z
        .object({
        valor_hora_persona_cop: z.number(),
        vigente_desde: z.string(),
    })
        .nullable(),
    /** Histórico descendente por vigencia. */
    historico: z.array(costoManoObraHistoricoItemSchema),
});
/**
 * Payload para fijar un nuevo costo MO. Crea una NUEVA vigencia (cierra la
 * abierta de esa planta y abre la nueva). `planta_id` opcional: si se omite, se
 * deriva de la planta del coordinador; obligatorio si el actor abarca >1 planta.
 */
export const costoManoObraUpsertSchema = z.object({
    valor_hora_persona_cop: z.number().positive().max(99999999999),
    vigente_desde: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha YYYY-MM-DD'),
    planta_id: z.string().uuid().optional(),
});
//# sourceMappingURL=coordinador_costo_mano_obra.js.map